import { render, staticRenderFns } from "./ImageBanner.vue?vue&type=template&id=60216702&"
import script from "./ImageBanner.vue?vue&type=script&lang=js&"
export * from "./ImageBanner.vue?vue&type=script&lang=js&"
import style0 from "./ImageBanner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports